import * as React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Input } from './Input.check.style'

interface InputTextProps {
    borderColor?: string | boolean
    id?: number | string
    isInRow?: boolean
    onChange?: Function
    ref: React.ForwardedRef<any>
    value?: boolean
}

function InputText(props: InputTextProps): JSX.Element {
    const { borderColor = undefined, id = undefined, isInRow = false, onChange = () => undefined, ref, value = false, ...rest } = props

    return (
        <Input ref={ref} borderColor={borderColor} onClick={(e) => onChange(e, id)} {...rest}>
            {value && <FontAwesomeIcon icon="check" style={{ marginBottom: isInRow ? '1px' : '9px' }} />}
        </Input>
    )
}

InputText.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.bool,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    borderColor: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    isInRow: PropTypes.bool,
}

InputText.defaultProps = {
    onChange: () => null,
    value: false,
    id: null,
    borderColor: null,
    isInRow: false,
}

export default InputText
